import { Button } from 'react-bootstrap';
import BaseModal from './BaseModal';

const ConfirmationModal = ({
  show = false,
  handleShow = () => null,
  bodyTxt,
  cancelBtnTxt,
  confirmBtnTxt,
  confirmHandler = () => null,
  cancelHandler = handleShow,
}) => {
  return (
    <BaseModal
      show={show}
      size="md"
      handleShow={handleShow}
      closeButton={false}
      backgroundColor="#fff"
      borderWidth="2px"
      borderColor="#436C9A"
    >
      <div className="d-flex flex-column justify-content-center align-items-center text-black text-center">
        <p className="fs-5 max-w-3xs mb-3">{bodyTxt}</p>
      </div>
      <div className="d-flex flex-column w-100 gap-2 flex-sm-row justify-content-sm-around">
        {cancelBtnTxt && (
          <Button
            className={`rounded-4 bg-dark fs-6 w-sm-50 btn-cancel`}
            onClick={(e) => {
              e.stopPropagation();
              cancelHandler();
            }}
            variant="secondary"
          >
            {cancelBtnTxt}
          </Button>
        )}
        <Button
          className="rounded-4 fs-6 w-sm-50"
          onClick={(e) => {
            e.stopPropagation();
            confirmHandler();
          }}
          variant="primary"
        >
          {confirmBtnTxt}
        </Button>
      </div>
    </BaseModal>
  );
};

export default ConfirmationModal;
